import { render, staticRenderFns } from "./RegisterFirebase.vue?vue&type=template&id=7271d3ba&scoped=true&"
import script from "./RegisterFirebase.vue?vue&type=script&lang=js&"
export * from "./RegisterFirebase.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFirebase.vue?vue&type=style&index=0&id=7271d3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7271d3ba",
  null
  
)

export default component.exports